import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { PixelPlaceholderLoader, ProgressBar } from "@similarweb/ui-components";
import { Box, Flex, Text } from "@similarweb/ui-components/foundations";

import { translate } from "app/filters/i18nFilter";
import { getMaxPrompts } from "app/pages/digital-marketing/generative-ai/llm-tracker/shared/LLMTrackerUtils";

const StyledProgressBar = styled(ProgressBar)`
    width: 40px;
    border-radius: 6px;
`;

interface IPromptsCounterProps {
    totalPrompts: number;
    isLoading?: boolean;
    lite?: boolean;
}

export const PromptsCounter = ({ totalPrompts, isLoading, lite }: IPromptsCounterProps) => {
    const maxPrompts = getMaxPrompts();
    const usagePercent = totalPrompts / maxPrompts;
    const isExceeding = usagePercent > 1;
    const isEmpty = totalPrompts <= 0;

    const description = lite
        ? `${totalPrompts}/${maxPrompts}`
        : translate("llm.prompts.edit.prompts-table.counter", {
              totalPrompts,
              maxPrompts,
          });

    return isLoading ? (
        <PixelPlaceholderLoader
            width={200}
            height={20}
        />
    ) : (
        <Flex
            alignItems="center"
            gap="12px"
        >
            {isExceeding ? (
                <Text
                    fontVariant="tooltip"
                    color={colorsPalettes.red["400_P"]}
                >
                    {translate("llm.prompts.edit.prompts-table.counter.exceed")}
                </Text>
            ) : null}
            {isEmpty ? (
                <Box
                    width="40px"
                    height="8px"
                    borderRadius="6px"
                    background={colorsPalettes.carbon[50]}
                    data-automation="llm-prompts-counter-empty-bar"
                />
            ) : (
                <StyledProgressBar
                    values={[usagePercent]}
                    colorSet={isExceeding ? [colorsPalettes.red["400_P"]] : undefined}
                />
            )}
            <Text
                data-automation="llm-prompts-counter-label"
                fontVariant={lite ? "captionTitle" : "input2"}
                color={colorsPalettes.carbon[400]}
            >
                {description}
            </Text>
        </Flex>
    );
};
